// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_pagination__XlZDI button, .style_pagination__XlZDI div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.style_interface_heading_row__gVwQz {
  display: flex;
  align-items: center;
}

.style_interface_noResults__uSB\\+z {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.style_main_transactions__g1FS6, .style_interface__VshVM {
  display: flex;
  flex-direction: column;
}

.style_main__ApTsD {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

a {
  text-decoration: none;
}

.style_link__bfGrW {
  cursor: pointer;
  color: #5c69f9;
}
.style_link__bfGrW:hover {
  text-decoration: underline;
}

.style_text-gradient-intel__WRD0x {
  font-weight: bold;
  background: #CE4F8C;
  background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.style_text-xs__isjj0 {
  font-size: 0.75rem; /* 12px */
  line-height: 1rem; /* 16px */
}
.style_text-sm__79lQl, .style_interface_heading__AKOqs, .style_interface_footer__w7dTp {
  font-size: 0.875rem; /* 14px */
  line-height: 1.25rem;
}
.style_text-base__Cbqiz {
  font-size: 1rem; /* 16px */
  line-height: 1.5rem; /* 24px */
}
.style_text-lg__Ew0KJ {
  font-size: 1.125rem; /* 18px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-lg__Ew0KJ {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-xl__0w-6l {
  font-size: 1.25rem; /* 20px */
  line-height: 1.75rem; /* 28px */
}
@media only screen and (max-width: 450px) {
  .style_text-xl__0w-6l {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.style_text-leading__Bv0i\\+ {
  line-height: 1.7rem;
}
@media only screen and (max-width: 450px) {
  .style_text-leading__Bv0i\\+ {
    line-height: 1.5rem;
  }
}

.style_breadcumb__xjsKP {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: var(--color-gray-400);
}
.style_breadcumb__xjsKP a,
.style_breadcumb__xjsKP span {
  padding: 3px 5px;
}
.style_breadcumb__xjsKP a {
  text-decoration: none;
  transition: color 0.3s;
  border-radius: 5px;
}
.style_breadcumb__xjsKP a:hover {
  color: var(--color-primary-500);
  background-color: var(--color-gray-800);
}
.style_breadcumb__xjsKP .style_divider__L\\+IdQ {
  color: var(--color-gray-400);
}

.style_badge__tzu1M {
  width: max-content;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badge__tzu1M.style_xs__FBmcn {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badge__tzu1M.style_sm__h6E4b {
  padding: 4px 7px;
}
.style_badge__tzu1M.style_primary__lcaVF {
  background: var(--color-primary-500);
}
.style_badge__tzu1M.style_primary__lcaVF, .style_badge__tzu1M.style_pm__bYGNZ {
  background: var(--color-primary-500);
}
.style_badge__tzu1M.style_sd__3ZuTO {
  background-color: var(--color-secundary-500);
}
.style_badge__tzu1M.style_Likely__QqE7L {
  background: var(--color-yellowdark-500);
  color: var(--color-yellowlight-300);
}
.style_badge__tzu1M.style_Unvalidated__SP02Z {
  background: var(--color-reddark-500);
  color: var(--color-redlight-300);
}
.style_badge__tzu1M.style_Verified__fIIeI, .style_badge__tzu1M.style_green__NLbkq {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badge__tzu1M.style_off__UIdX5 {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_badgeTable__4Zrix {
  width: max-content;
  border-radius: 8px;
  font-size: 13px;
  color: white;
  gap: 5px;
  padding: 6px 9px;
}
.style_badgeTable__4Zrix.style_xs__FBmcn {
  padding: 3px 5px;
  font-size: 12px;
}
.style_badgeTable__4Zrix.style_sm__h6E4b {
  padding: 4px 7px;
}
.style_badgeTable__4Zrix.style_primary__lcaVF, .style_badgeTable__4Zrix.style_pm__bYGNZ {
  background: var(--color-primary-500);
}
.style_badgeTable__4Zrix.style_sd__3ZuTO {
  background-color: var(--color-secundary-500);
}
.style_badgeTable__4Zrix.style_Likely__QqE7L {
  background: #413e1a;
  color: #e6f979;
}
.style_badgeTable__4Zrix.style_Verified__fIIeI, .style_badgeTable__4Zrix.style_green__NLbkq {
  background-color: var(--color-greendark-500);
  color: var(--color-greenlight-300);
}
.style_badgeTable__4Zrix.style_off__UIdX5 {
  color: var(--color-white-500);
  background-color: var(--color-gray-700);
}

.style_table__YAy0P {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}
.style_table__YAy0P.style_style-1__sxmd5 td,
.style_table__YAy0P.style_style-1__sxmd5 th {
  padding: 12px 1rem;
  font-size: 0.875rem;
}
.style_table__YAy0P.style_style-1__sxmd5 th,
.style_table__YAy0P.style_style-1__sxmd5 td.style_label__djjEq {
  color: var(--color-white-500);
}
.style_table__YAy0P.style_style-1__sxmd5 th {
  font-weight: normal;
  border-style: solid;
  border-color: var(--color-gray-100);
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.style_table__YAy0P.style_style-1__sxmd5 tr.style_noBorder__rakXM td {
  border-bottom: none;
}
.style_table__YAy0P.style_style-1__sxmd5 tr td {
  color: var(--color-white-500);
}

.style_pagination__XlZDI {
  display: inline-flex;
  height: 38px;
  border: 1px solid var(--color-gray-700);
  border-radius: 8px;
  width: max-content;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none;
}
.style_pagination__XlZDI button {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__XlZDI button:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__XlZDI button:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
@media only screen and (max-width: 450px) {
  .style_pagination__XlZDI button {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__XlZDI button.style_disabled__KlSjo, .style_pagination__XlZDI button.style_active__nomah, .style_pagination__XlZDI button.style_info__qXS8V {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__XlZDI button.style_disabled__KlSjo {
  color: var(--color-gray-700);
}
.style_pagination__XlZDI div {
  text-shadow: 2px 2px 2px var(--color-gradient-black-500);
  padding: 0 10px;
  height: 100%;
  font-size: 15px;
  display: flex;
  color: var(--color-white-500);
  border-right: 1px solid var(--color-gray-700);
}
.style_pagination__XlZDI div:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}
.style_pagination__XlZDI div:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
}
.style_pagination__XlZDI div:hover, .style_pagination__XlZDI div.style_active__nomah {
  cursor: pointer;
  background: linear-gradient(var(--color-paper-400), rgba(0, 0, 0, 0.9)) top/100% 500%;
}
@media only screen and (max-width: 450px) {
  .style_pagination__XlZDI div {
    padding: 0 13px;
    font-size: 14px;
  }
}
.style_pagination__XlZDI div.style_disabled__KlSjo, .style_pagination__XlZDI div.style_active__nomah, .style_pagination__XlZDI div.style_info__qXS8V {
  cursor: pointer;
  pointer-events: none;
}
.style_pagination__XlZDI div.style_disabled__KlSjo {
  color: var(--color-gray-700);
}
.style_pagination__XlZDI div:last-child, .style_pagination__XlZDI div:first-child {
  padding: 0 10px;
}
.style_pagination__XlZDI div:last-child {
  border-right: none;
}
.style_pagination__XlZDI button:last-child, .style_pagination__XlZDI button:first-child {
  padding: 0 10px;
}
.style_pagination__XlZDI button:last-child {
  border-right: none;
}

.style_interface__VshVM {
  width: 100%;
  border-radius: 10px;
  border-left: 2px solid var(--color-gray-800);
  border-right: 2px solid var(--color-gray-800);
  background-color: var(--color-gray-100);
  box-shadow: 0px 2px 11px 0px rgba(255, 255, 255, 0.1);
}
.style_interface_heading__AKOqs {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 8px 8px 0 0;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading__AKOqs {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_heading__AKOqs > div {
    width: 100%;
  }
}
.style_interface_heading_row__gVwQz {
  justify-content: space-between;
  width: 100%;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_heading_row__gVwQz {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_footer__w7dTp {
  gap: 15px;
  flex-direction: column;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 10px;
  border-radius: 0 0 8px 8px;
}
@media only screen and (max-width: 450px) {
  .style_interface_footer__w7dTp {
    padding: 12px 10px;
    align-items: flex-start;
  }
  .style_interface_footer__w7dTp > div {
    width: 100%;
  }
}
.style_interface_foot__NZ4AH {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}
@media only screen and (max-width: 450px) {
  .style_interface_foot__NZ4AH {
    flex-direction: column;
    align-items: flex-start;
  }
}
.style_interface_noResults__uSB\\+z {
  gap: 15px;
  padding: 70px 0;
}

.style_main__ApTsD {
  padding-top: 40px;
  padding-bottom: 80px;
  margin: auto;
  gap: 40px;
  width: 712px;
}
@media only screen and (max-width: 810px) {
  .style_main__ApTsD {
    gap: 25px;
    width: 100%;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 60px;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}
.style_main_transactions__g1FS6 {
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_flex.scss","webpack://./src/pages/Billing/style.module.scss","webpack://./src/assets/scss/theme/_typography.scss","webpack://./src/assets/scss/_breakpoint.scss","webpack://./src/assets/scss/theme/_breadcumb.scss","webpack://./src/assets/scss/theme/_badge.scss","webpack://./src/assets/scss/theme/_table.scss","webpack://./src/assets/scss/theme/_pagination.scss","webpack://./src/assets/scss/theme/_global.scss","webpack://./src/assets/scss/theme/_interface.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;ACCF;;ADaA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ACVF;;AD6BA;EACE,aAAA;EACA,sBAAA;AC1BF;;AD6BA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AC1BF;;ACpBA;EACI,qBAAA;ADuBJ;;ACrBA;EACI,eAAA;EACA,cAAA;ADwBJ;ACvBI;EACE,0BAAA;ADyBN;;ACrBA;EACI,iBAAA;EACA,mBAAA;EACA,+DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;ADwBJ;;ACrBI;EACI,kBAAA,EAAA,SAAA;EACA,iBAAA,EAAA,SAAA;ADwBR;ACtBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA;ADwBR;ACtBI;EACI,eAAA,EAAA,SAAA;EACA,mBAAA,EAAA,SAAA;ADwBR;ACtBI;EACI,mBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;ADwBR;AEhEE;EDsCE;IAIQ,eAAA;IACA,mBAAA;ED0BV;AACF;ACxBI;EACI,kBAAA,EAAA,SAAA;EACA,oBAAA,EAAA,SAAA;AD0BR;AE1EE;ED8CE;IAIQ,eAAA;IACA,mBAAA;ED4BV;AACF;AC1BI;EACI,mBAAA;AD4BR;AEnFE;EDsDE;IAGQ,mBAAA;ED8BV;AACF;;AGtFA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,4BAAA;AHyFF;AGxFE;;EAEE,gBAAA;AH0FJ;AGxFE;EACE,qBAAA;EACA,sBAAA;EACA,kBAAA;AH0FJ;AGzFI;EACE,+BAAA;EACA,uCAAA;AH2FN;AGxFE;EACE,4BAAA;AH0FJ;;AI9GA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJiHF;AI9GE;EACE,gBAAA;EACA,eAAA;AJgHJ;AI9GE;EACE,gBAAA;AJgHJ;AI5GE;EACE,oCAAA;AJ8GJ;AI5GE;EAEE,oCAAA;AJ6GJ;AI3GE;EACE,4CAAA;AJ6GJ;AI3GE;EACE,uCAAA;EACA,mCAAA;AJ6GJ;AI3GE;EACE,oCAAA;EACA,gCAAA;AJ6GJ;AI3GE;EAEE,4CAAA;EACA,kCAAA;AJ4GJ;AI1GE;EACE,6BAAA;EACA,uCAAA;AJ4GJ;;AIzGA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;AJ4GF;AIzGE;EACE,gBAAA;EACA,eAAA;AJ2GJ;AIzGE;EACE,gBAAA;AJ2GJ;AIvGE;EAEE,oCAAA;AJwGJ;AItGE;EACE,4CAAA;AJwGJ;AItGE;EACE,mBAAA;EACA,cAAA;AJwGJ;AItGE;EAEE,4CAAA;EACA,kCAAA;AJuGJ;AIrGE;EACE,6BAAA;EACA,uCAAA;AJuGJ;;AK/LA;EACE,yBAAA;EACA,WAAA;EACA,mBAAA;ALkMF;AKhMI;;EAEE,kBAAA;EACA,mBAAA;ALkMN;AKhMI;;EAEE,6BAAA;ALkMN;AKhMI;EACE,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,qBAAA;EACA,wBAAA;ALkMN;AK/LM;EACE,mBAAA;ALiMR;AK/LM;EACE,6BAAA;ALiMR;;AMrNA;EACI,oBAAA;EACA,YAAA;EAEA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA,EAAA,WAAA,EACA,oBAAA;EACA,iBAAA;ANuNJ;AMrNI;ELbA,wDAAA;EKgBI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;ANsNR;AMrNQ;EACI,2BAAA;EACA,8BAAA;ANuNZ;AMrNQ;EACI,4BAAA;EACA,+BAAA;ANuNZ;AEtPE;EIgBE;IAkBQ,eAAA;IACA,eAAA;ENwNV;AACF;AMvNQ;EACI,eAAA;EACA,oBAAA;ANyNZ;AMvNQ;EACI,4BAAA;ANyNZ;AMtNI;EL1CA,wDAAA;EK6CI,eAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;EACA,6CAAA;ANuNR;AMtNQ;EACI,2BAAA;EACA,8BAAA;ANwNZ;AMtNQ;EACI,4BAAA;EACA,+BAAA;ANwNZ;AMtNQ;ECrCJ,eAAA;EACA,qFAAA;AP8PJ;AExRE;EI6CE;IAqBQ,eAAA;IACA,eAAA;EN0NV;AACF;AMzNQ;EACI,eAAA;EACA,oBAAA;AN2NZ;AMzNQ;EACI,4BAAA;AN2NZ;AMxNI;EACI,eAAA;AN0NR;AMxNI;EACI,kBAAA;AN0NR;AMxNI;EACI,eAAA;AN0NR;AMxNI;EACI,kBAAA;AN0NR;;AQ5SA;EACE,WAAA;EACA,mBAAA;EACA,4CAAA;EACA,6CAAA;EACA,uCAAA;EAGA,qDAAA;AR+SF;AQ7SE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;AR8SJ;AEtUE;EMeA;IAWI,kBAAA;IACA,uBAAA;ERgTJ;EQ/SI;IACE,WAAA;ERiTN;AACF;AQ/SI;EAEE,8BAAA;EACA,WAAA;EACA,SAAA;ARgTN;AEpVE;EMgCE;IAMI,sBAAA;IACA,uBAAA;ERkTN;AACF;AQ/SE;EACE,SAAA;EACA,sBAAA;EACA,aAAA;EAEA,8BAAA;EAEA,mBAAA;EACA,kBAAA;EACA,0BAAA;ARgTJ;AEpWE;EM2CA;IAWI,kBAAA;IACA,uBAAA;ERkTJ;EQjTI;IACE,WAAA;ERmTN;AACF;AQhTE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;ARkTJ;AElXE;EM6DA;IAKI,sBAAA;IACA,uBAAA;ERoTJ;AACF;AQlTE;EAEE,SAAA;EACA,eAAA;ARmTJ;;AA3XA;EOEI,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,SAAA;EAMI,YAAA;APwXR;AExXE;EFXF;IOcQ,SAAA;IACA,WAAA;IACA,8BAAA;IACA,iBAAA;IACA,oBAAA;IACA,6BAAA;IACA,8BAAA;EPyXN;AACF;AA3YE;EAEE,SAAA;AA4YJ","sourcesContent":["%flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-align {\n  display: flex;\n  align-items: center;\n}\n\n%flex-stretch {\n  display: flex;\n  align-items: stretch;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n%flex-column-align {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n%flex-justify-center {\n  display: flex;\n  justify-content: center;\n}\n\n%flex-justify-between-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%flex-justify-between {\n  display: flex;\n  justify-content: space-between;\n}\n\n%flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n%flex-column-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-center-reverse {\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n  justify-content: center;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n%flex-align-end {\n  display: flex;\n  justify-content: flex-end;\n}\n\n%flex-start {\n  display: flex;\n  justify-content: flex-start;\n}\n\n%flex-column-align-start {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n%flex-align-start {\n  display: flex;\n  align-items: flex-start;\n}\n\n%flex-justify-evenly {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n%flex-justify-evenly-center {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n%flex-column-justify-center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}","@use \"/src/assets/scss/\" as *;\n\n.main {\n  @extend %flex-column-center;\n  @include container('sm');\n  &_transactions {\n    @extend %flex-column;\n    gap: 20px;\n\n    // &_heading {\n    //   @extend %flex-justify-between-center;\n      \n    //   @include middleTablet {\n    //     flex-direction: column;\n    //     align-items: flex-start;\n    //     // padding: 0 16px;\n    //   }\n    // }\n\n    // @include middleTablet {\n    //   width: 100%;\n    // }\n  }\n\n}\n","@use \"../breakpoint\" as *;\n@use \"../colors\" as *;\n\n@mixin textShadow() {\n    text-shadow: 2px 2px 2px $color-gradient-black-500;\n}\n\na {\n    text-decoration: none;\n}\n.link {\n    cursor: pointer;\n    color: #5c69f9;\n    &:hover{\n      text-decoration: underline;\n    }\n}\n\n.text-gradient-intel {\n    font-weight: bold;\n    background: #CE4F8C;\n    background: linear-gradient(to right, #CE4F8C 0%, #4720E2 100%);\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n.text {\n    &-xs {\n        font-size: 0.75rem; /* 12px */\n        line-height: 1rem; /* 16px */\n    }\n    &-sm {\n        font-size: 0.875rem; /* 14px */\n        line-height: 1.25rem;\n    }\n    &-base {\n        font-size: 1rem; /* 16px */\n        line-height: 1.5rem; /* 24px */\n    }\n    &-lg {\n        font-size: 1.125rem; /* 18px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-xl {\n        font-size: 1.25rem; /* 20px */\n        line-height: 1.75rem; /* 28px */\n        @include mobile {\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n    }\n    &-leading {\n        line-height: 1.7rem;\n        @include mobile {\n            line-height: 1.5rem; \n        }\n    }\n}","@mixin mobile {\n  @media only screen and (max-width: 450px) {\n    @content;\n  }\n}\n\n@mixin mobileH {\n  @media only screen and (max-height: 710px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: 810px) {\n    @content;\n  }\n}\n\n@mixin middle {\n  @media only screen and (max-width: 576px) {\n    @content;\n  }\n}\n\n@mixin middleTablet {\n  @media only screen and (max-width: 780px) {\n    @content;\n  }\n}\n","@use \"../colors\" as *;\n// @use \"./typography\" as *;\n\n.breadcumb {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  color: var(--color-gray-400);\n  a,\n  span {\n    padding: 3px 5px;\n  }\n  a {\n    text-decoration: none;\n    transition: color 0.3s;\n    border-radius: 5px;\n    &:hover {\n      color: var(--color-primary-500);\n      background-color: var(--color-gray-800);\n    }\n  }\n  .divider {\n    color: var(--color-gray-400);\n  }\n}\n","@use \"../colors\" as *;\n@use \"./typography\" as *;\n\n.badge {\n  width: max-content;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary {\n    background: var(--color-primary-500);\n  }\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: var(--color-yellowdark-500);\n    color: var(--color-yellowlight-300);\n  }\n  &.Unvalidated {\n    background: var(--color-reddark-500);\n    color: var(--color-redlight-300);\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n.badgeTable {\n  width: max-content;\n  border-radius: 8px;\n  font-size: 13px;\n  color: white;\n  gap: 5px;\n  padding: 6px 9px;\n\n  // SIZES\n  &.xs {\n    padding: 3px 5px;\n    font-size: 12px;\n  }\n  &.sm {\n    padding: 4px 7px;\n  }\n\n  // COLORS\n  &.primary,\n  &.pm {\n    background: var(--color-primary-500);\n  }\n  &.sd {\n    background-color: var(--color-secundary-500);\n  }\n  &.Likely {\n    background: #413e1a;\n    color: #e6f979;\n  }\n  &.Verified,\n  &.green {\n    background-color: var(--color-greendark-500);\n    color: var(--color-greenlight-300);\n  }\n  &.off {\n    color: var(--color-white-500);\n    background-color: var(--color-gray-700);\n  }\n}\n",".table {\n  border-collapse: collapse;\n  width: 100%;\n  table-layout: fixed;\n  &.style-1 {\n    td,\n    th {\n      padding: 12px 1rem;\n      font-size: 0.875rem;\n    }\n    th,\n    td.label {\n      color: var(--color-white-500);\n    }\n    th {\n      font-weight: normal;\n      border-style: solid;\n      border-color: var(--color-gray-100);\n      border-top-width: 1px;\n      border-bottom-width: 1px;\n    }\n    tr {\n      &.noBorder td {\n        border-bottom: none;\n      }\n      td {\n        color: var(--color-white-500);\n        // border-bottom: 1px solid var(--color-paper-400);\n      }\n    }\n  }\n}\n","@use \"../colors\" as *;\n@use \"../flex\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"./typography\" as *;\n\n.pagination {\n    display: inline-flex;\n    height: 38px;\n    // background-color: var(--color-paper-400);\n    border: 1px solid var(--color-gray-700);\n    border-radius: 8px;\n    width: max-content;\n    -webkit-user-select: none; /* Safari */\n    -ms-user-select: none; /* IE 10 and IE 11 */\n    user-select: none;\n    // @include boxShadow();\n    button {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div {\n        @extend %flex-center;        \n        @include textShadow();\n        padding: 0 10px;\n        height: 100%;\n        font-size: 15px;\n        display: flex;\n        color: var(--color-white-500);\n        border-right: 1px solid var(--color-gray-700);\n        &:first-child {\n            border-top-left-radius: 8px;\n            border-bottom-left-radius: 8px;\n        }\n        &:last-child {\n            border-top-right-radius: 8px;\n            border-bottom-right-radius: 8px;\n        }\n        &:hover, &.active {\n            @include bgHover(var(--color-paper-400));\n        }\n        @include mobile {\n            padding: 0 13px;\n            font-size: 14px;\n        }\n        &.disabled, &.active, &.info {\n            cursor: pointer;\n            pointer-events: none;\n        }\n        &.disabled {\n            color: var(--color-gray-700);\n        }\n    }\n    div:last-child, div:first-child {\n        padding: 0 10px;\n    }\n    div:last-child {\n        border-right: none;\n    }\n    button:last-child, button:first-child {\n        padding: 0 10px;\n    }\n    button:last-child {\n        border-right: none;\n    }\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n\n@mixin container($width: 'base', $padding-top: 40) {\n    padding-top: $padding-top+px;\n    padding-bottom: 80px;\n    margin: auto;\n    gap: 40px;\n\n    @if $width == 'base' {\n        // width: $container-width;\n    }\n    @else if $width == 'sm' {\n        width: 712px;\n    }\n    @include tablet {\n        gap: 25px;\n        width: 100%;\n        justify-content: space-between;\n        padding-top: 25px;\n        padding-bottom: 60px;\n        padding-left: 20px !important;\n        padding-right: 20px !important;\n    }\n}\n@mixin bgHover($bg: 'black', $opacity: 90%, $r: 0, $g: 0, $b: 0) {\n    cursor: pointer;\n    background: linear-gradient($bg, rgb($r $g $b / #{$opacity})) top/100% 500%;\n}\n@mixin boxShadow() {\n    -webkit-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    -moz-box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n    box-shadow: 4px 6px 5px 0px $color-gradient-black-200;\n}","@use \"../colors\" as *;\n@use \"../breakpoint\" as *;\n@use \"./global\" as *;\n@use \"../flex\" as *;\n@use \"./typography\" as *;\n\n.interface {\n  width: 100%;\n  border-radius: 10px;\n  border-left: 2px solid var(--color-gray-800); \n  border-right: 2px solid var(--color-gray-800);\n  background-color: var(--color-gray-100);\n  -webkit-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  -moz-box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  box-shadow: 0px 2px 11px 0px rgba(255,255,255,0.1);\n  @extend %flex-column;\n  &_heading {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 8px 8px 0 0;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n    &_row {\n      @extend %flex-align;\n      justify-content: space-between;\n      width: 100%;\n      gap: 15px;\n      @include mobile {\n        flex-direction: column;\n        align-items: flex-start;\n      } \n    }\n  }\n  &_footer {\n    gap: 15px;\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    @extend .text-sm;\n    align-items: center;\n    padding: 15px 10px;\n    border-radius: 0 0 8px 8px;\n    @include mobile {\n      padding: 12px 10px;\n      align-items: flex-start;\n      > div {\n        width: 100%;\n      }\n    }\n  }\n  &_foot {\n    display: flex;\n    justify-content: flex-end;\n    gap: 15px;\n    @include mobile {\n      flex-direction: column;\n      align-items: flex-start\n    }\n  }\n  &_noResults {\n    @extend %flex-column-align;\n    gap: 15px;\n    padding: 70px 0;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `style_pagination__XlZDI`,
	"interface_heading_row": `style_interface_heading_row__gVwQz`,
	"interface_noResults": `style_interface_noResults__uSB+z`,
	"main_transactions": `style_main_transactions__g1FS6`,
	"interface": `style_interface__VshVM`,
	"main": `style_main__ApTsD`,
	"link": `style_link__bfGrW`,
	"text-gradient-intel": `style_text-gradient-intel__WRD0x`,
	"text-xs": `style_text-xs__isjj0`,
	"text-sm": `style_text-sm__79lQl`,
	"interface_heading": `style_interface_heading__AKOqs`,
	"interface_footer": `style_interface_footer__w7dTp`,
	"text-base": `style_text-base__Cbqiz`,
	"text-lg": `style_text-lg__Ew0KJ`,
	"text-xl": `style_text-xl__0w-6l`,
	"text-leading": `style_text-leading__Bv0i+`,
	"breadcumb": `style_breadcumb__xjsKP`,
	"divider": `style_divider__L+IdQ`,
	"badge": `style_badge__tzu1M`,
	"xs": `style_xs__FBmcn`,
	"sm": `style_sm__h6E4b`,
	"primary": `style_primary__lcaVF`,
	"pm": `style_pm__bYGNZ`,
	"sd": `style_sd__3ZuTO`,
	"Likely": `style_Likely__QqE7L`,
	"Unvalidated": `style_Unvalidated__SP02Z`,
	"Verified": `style_Verified__fIIeI`,
	"green": `style_green__NLbkq`,
	"off": `style_off__UIdX5`,
	"badgeTable": `style_badgeTable__4Zrix`,
	"table": `style_table__YAy0P`,
	"style-1": `style_style-1__sxmd5`,
	"label": `style_label__djjEq`,
	"noBorder": `style_noBorder__rakXM`,
	"disabled": `style_disabled__KlSjo`,
	"active": `style_active__nomah`,
	"info": `style_info__qXS8V`,
	"interface_foot": `style_interface_foot__NZ4AH`
};
export default ___CSS_LOADER_EXPORT___;
